import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import _ from "lodash";

function resetSavedData() {
  return actions.resetDataSaved();
}

function obtenerIncidencias(idAlumno) {
  return dispatch => {
    rootRef.child(`incidencias/${idAlumno}`).on("child_added", snap => {
      dispatch(actions.obtenerIncidencias(snap.val()));
    });

    rootRef.child(`incidencias/${idAlumno}`).on("child_changed", snap => {
      dispatch(actions.incidenciaModificada(snap.val()));
    });

    rootRef.child(`incidencias/${idAlumno}`).on("child_removed", snap => {
      dispatch(actions.incidenciaEliminada(snap.val()));
    });
  };
}

function resetIncidencias() {
  return actions.resetIncidencias();
}

function detachIncidencias(idAlumno) {
  return dispatch => rootRef.child(`incidencias/${idAlumno}`).off();
}

function obtenerIncidenciasTodos() {
  return dispatch => {
    rootRef.child("incidencias").on("child_added", snap => {
      const datos = snap.val();
      _.forOwn(datos, (payload, k) => {
        dispatch(actions.obtenerIncidencias(payload));
      });
    });

    rootRef.child("incidencias").on("child_changed", snap => {
      const datos = snap.val();
      _.forOwn(datos, (payload, k) => {
        dispatch(actions.incidenciaModificada(payload));
      });
    });

    rootRef.child("incidencias").on("child_removed", snap => {
      const datos = snap.val();
      _.forOwn(datos, (payload, k) => {
        dispatch(actions.incidenciaEliminada(payload));
      });
    });
  };
}

function detachIncidenciasTodos() {
  return dispatch => rootRef.child("incidencias").off();
}

function cerrarIncidencia({ incidencia, user }) {
  const { idAlumno, id } = incidencia;

  let insert = {};
  insert[`incidencias/${idAlumno}/${id}/cerrada`] = true;
  insert[`incidencias/${idAlumno}/${id}/fechaCierre`] = new Date().getTime();
  insert[`incidencias/${idAlumno}/${id}/userIDCierre`] = user.uid;
  insert[`incidencias/${idAlumno}/${id}/userNameCierre`] = user.email.split(
    "@"
  )[0];

  return dispatch => rootRef.update(insert);
}

function guardarIncidencia({ alumno, id, texto, user }) {
  const key = (_.isEmpty(id) && rootRef.child("/incidencias").push().key) || id;
  const fecha = (_.isEmpty(id) && new Date().getTime()) || false;
  const { id: idAlumno, nombre, apellido1, apellido2 } = alumno;

  let insert = {};

  insert[`incidencias/${idAlumno}/${key}/id`] = key;
  insert[`incidencias/${idAlumno}/${key}/userid`] = user.uid;
  insert[`incidencias/${idAlumno}/${key}/userName`] = user.email.split("@")[0];
  fecha && (insert[`incidencias/${idAlumno}/${key}/fecha`] = fecha);
  insert[`incidencias/${idAlumno}/${key}/cerrada`] = false;
  insert[`incidencias/${idAlumno}/${key}/fechaCierre`] = false;
  insert[`incidencias/${idAlumno}/${key}/comentario`] = texto;
  insert[`incidencias/${idAlumno}/${key}/userIDCierre`] = "";
  insert[`incidencias/${idAlumno}/${key}/userNameCierre`] = "";
  insert[`incidencias/${idAlumno}/${key}/idAlumno`] = idAlumno;
  insert[`incidencias/${idAlumno}/${key}/nombreAlumno`] = nombre;
  insert[
    `incidencias/${idAlumno}/${key}/apellidosAlumno`
  ] = `${apellido1} ${apellido2}`;

  return dispatch => rootRef.update(insert);
}

/*---*/
export {
  resetSavedData,
  obtenerIncidencias,
  resetIncidencias,
  detachIncidencias,
  obtenerIncidenciasTodos,
  detachIncidenciasTodos,
  cerrarIncidencia,
  guardarIncidencia
};



// WEBPACK FOOTER //
// ./src/ducks/incidencias/operations.js